import { NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION } from '../../../constants/terms-and-conditions-version'
import { getPassMinimumFields } from '../../../services/modal-services'
import {
  useModalCompleteProfileStore,
  useModalTermsConditionsStore
} from '../../../store'
import { useModalBrokerInvitationStore } from '../../../store/modals-services/modal-broker-invitation'
import { rolesByAuthUser } from '../../../../auth/utils/roles'
import { getAgencyInvites } from '../../../services/invitations-services'
import type { IAuthUser, IProfileUser } from '../../../../interfaces/src'

interface useShowRestModalsProps {
  termsAndConditions: IProfileUser['termsAndConditions']
  profile: IProfileUser
  authUser: IAuthUser
}

export const useShowRestModals = ({
  termsAndConditions,
  profile,
  authUser
}: useShowRestModalsProps) => {
  const { isAssociation } = rolesByAuthUser(authUser)
  const setIsOpenModalCompleteProfile = useModalCompleteProfileStore(
    (state) => state.setIsOpen
  )
  const setIsOpenModalTermsAndConditions = useModalTermsConditionsStore(
    (state) => state.setIsOpen
  )

  const setIsOpenModalBrokerInvitation = useModalBrokerInvitationStore(
    (state) => state.setIsOpen
  )

  const handleShowModalCompleteProfile = async () => {
    const { data, isSuccess } = await getPassMinimumFields()
    if (isSuccess && data && !data?.profileCompleted) {
      const defaultDataForm = {
        ...data,
        phoneNumber: data?.phoneNumber?.replace('+52', '')
      }
      setIsOpenModalCompleteProfile({ isOpen: true, defaultDataForm })
    }
  }

  const handleShowModalTermsAndConditions = () => {
    if (
      (!termsAndConditions ||
        termsAndConditions !== NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION) &&
      profile?.email
    ) {
      setIsOpenModalTermsAndConditions(true)
    }
  }

  const handleShowModalBrokerInvitation = async () => {
    if (!isAssociation) {
      const { isSuccess, data } = await getAgencyInvites({
        email: profile?.email,
        status: ['PENDING', 'ACCEPTED', 'REJECTED'],
        requestType: 'REQUEST'
      })
      const lastInvitation = data?.[0]
      if (isSuccess && lastInvitation && !lastInvitation?.statusAccepted) {
        setIsOpenModalBrokerInvitation({
          isOpen: true,
          status: lastInvitation?.status,
          brokerAgencyRequestExists: true,
          invitationData: lastInvitation
        })
      } else {
        setIsOpenModalBrokerInvitation({
          isOpen: false,
          status: undefined,
          invitationData: undefined,
          brokerAgencyRequestExists: false
        })
      }
    }
  }

  const handleShowRestModals = () => {
    handleShowModalCompleteProfile()
    handleShowModalTermsAndConditions()
    handleShowModalBrokerInvitation()
  }

  return { handleShowRestModals }
}
